/**
 *
 * @module temporaryAccess
 *
 */

/**
 *
 * @class TemporaryAccess
 *
 */
export default class TemporaryAccess {

    constructor() {

        /**
         *
         * @access public
         *
         */
        this.error = {};

    }

}



// WEBPACK FOOTER //
// ./src/status/temporaryAccess.js